import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { fetchJSONFactory } from "@/utils/fetch-json";

const USERS_API = import.meta.env.VITE_USERS_API;
const fetchJSON = fetchJSONFactory(USERS_API);

export type AutoRenewStatus = {
  isEnrolled: boolean;
  studioCode?: string;
};

export const AutoRenewQueryKey = ["auto-renew"];

export function useAutoRenewStatus(studioCode?: string) {
  return useQuery({
    queryKey: [...AutoRenewQueryKey, studioCode],
    queryFn: async (): Promise<AutoRenewStatus> => {
      if (!studioCode) {
        return { isEnrolled: false };
      }

      try {
        const response = await fetchJSON<AutoRenewStatus>(
          `auto-renew/status?studio_code=${studioCode}`,
        );
        return response;
      } catch (error) {
        // If the endpoint doesn't exist yet, assume user is not enrolled
        return { isEnrolled: false, studioCode };
      }
    },
    enabled: !!studioCode,
  });
}

export function useEnrollToAutoRenewMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (studioCode: string) => {
      return fetchJSON("auto-renew/enroll", {
        method: "POST",
        body: { studio_code: studioCode },
      });
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: AutoRenewQueryKey });
    },
  });
}
